/** Vrai pour un nom ng-icon (Heroicons, maison EVA), faux pour une classe PrimeIcons. */
export function isNgIconName(icon: string | null | undefined): boolean {
  return !!icon && /^(hero|eva)[A-Z]/.test(icon);
}
